import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    SearchMyNetworkStateInterface,
    SearchMyNetworkFormInterface,
    ResponseSearchMyNetworkInterface,
} from '../../domain';

const initialState: SearchMyNetworkStateInterface = {
    formData: {
        value: ''
    },
    loading: false,
    error: false,
    success: false,
    responseSearchMyNetwork: {
        message: '',
        success: false,
        data: {
            direct: 0,
            indirect: 0,
            userName: ''
        }
    }
};

const SearchMyNetworkSlice = createSlice({
    name: 'searchMyNetwork',
    initialState,
    reducers: {
        setFormDataReducer: (state, action: PayloadAction<Partial<SearchMyNetworkFormInterface>>) => {
            state.formData = { ...state.formData, ...action.payload };
        },
        submitRegistrationStartReducer: (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
        },
        submitRegistrationSuccessReducer: (state, action: PayloadAction<ResponseSearchMyNetworkInterface>) => {
            state.loading = false;
            state.success = true;
            state.error = null;
            state.formData = initialState.formData;
            state.responseSearchMyNetwork = action.payload;
        },
        submitRegistrationFailureReducer: (state, action: PayloadAction<string>) => {
            state.loading = false;
            state.error = true;
            state.success = false;
            state.responseSearchMyNetwork.message = action.payload;

        },
        clearRegistrationErrorReducer: (state) => {
            state.error = null;
            state.success = false;
        },
        resetRegistrationStateReducer: () => {
            return initialState
        }
    },
});

export const {
    setFormDataReducer,
    submitRegistrationStartReducer,
    submitRegistrationSuccessReducer,
    submitRegistrationFailureReducer,
    clearRegistrationErrorReducer,
    resetRegistrationStateReducer
} = SearchMyNetworkSlice.actions;

export default SearchMyNetworkSlice.reducer;
